/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_mcp/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
      root.style.backgroundImage = `url(${toAbsoluteUrl('/media/auth/login-wp.png')})`
      root.style.backgroundRepeat = 'no-repeat'
      root.style.backgroundSize = 'cover'
      root.style.backgroundPosition = 'center'
    }
    return () => {
      if (root) {
        root.style.height = '100%'
        root.style.backgroundImage = `url(${toAbsoluteUrl('/media/auth/login-wp.png')})`
        root.style.backgroundRepeat = 'no-repeat'
        root.style.backgroundSize = 'cover'
        root.style.backgroundPosition = 'center'
      }
    }
  }, [])

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-column-fluid flex-lg-row">
        {/* Bagian kiri */}
        <div
          className="d-flex flex-column w-lg-50"
          style={{
            paddingLeft: "7rem",
            paddingTop: "14rem",
          }}
        >
          <Link to="/" style={{ marginBottom: "1rem" }}>
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/Logo.png")}
              className="h-100px"
            />
          </Link>
          <h2 className="text-black fw-normal m-0" style={{ marginLeft: "1rem" }}>
            UOnePay - Sending Money Dashboard
          </h2>
        </div>

  
        {/* Bagian kanan */}
        <div className="d-flex flex-center w-lg-50 pt-xl-20 mt-xl-5 p-10">
          <div className="card rounded-3 w-md-550px">
            <div className="card-body p-10 p-lg-20">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export {AuthLayout}
